import React from 'react';
import { Badge } from '@razorpay/blade/components';

export const StatusBadge = ({ isActive }: { isActive?: boolean }) => {
  return isActive ? <Badge color="positive">Active</Badge> : <Badge color="notice">Disabled</Badge>;
};
